import React, { useEffect, useState } from 'react';
import { Navbar, Nav, Table, Dropdown } from 'react-bootstrap';
import { Link, useParams } from 'react-router-dom';
import Cookies from 'universal-cookie';

function CarePlans() {
    const { id } = useParams(); // Extract the customer ID from the URL
    const [carePlans, setCarePlans] = useState([]); // Holds multiple care plans
    const [customerName, setCustomerName] = useState('');

    useEffect(() => {
        const cookies = new Cookies();
        const token = cookies.get('token'); 
        const fetchData = async () => {
            try {
                const response = await fetch(`https://api.cpq.yourcrm.co.za/api/careplans/${id}`,{
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json',
                    }
                });
                const data = await response.json();

                // Check if the response contains an array of care plans
                if (data.carePlans) {
                    setCarePlans(data.carePlans); // Set the care plans array
                    setCustomerName(data.customerName || 'Unknown');
                } else {
                    console.error('Expected an array of care plans');
                    setCarePlans([]); // Fallback to an empty array if data is not found
                }
            } catch (error) {
                console.error('Error fetching care plans:', error);
                setCarePlans([]); // Fallback to an empty array on error
            }
        };

        fetchData();
    }, [id]);

    return (
        <div>

            <div className="container mt-4">
                <h1>Care Plans for {customerName}</h1>
                <p>Manage Care Plans for the selected care recipient here.</p>

                <Table striped bordered hover>
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Date Created</th>
                            <th>Care Plan ID</th>
                        </tr>
                    </thead>
                    <tbody>
                        {carePlans.length > 0 ? (
                            carePlans.map((plan, index) => (
                                <tr key={plan.CarePlanID}>
                                    <td>{index + 1}</td>
                                    <td>{plan.DateCreated}</td>
                                    <td>
                                        {/* <Link to={`/careplan/${id}/${plan.DateCreated}/${plan.CarePlanID}`}> */}
                                        <Link to={`/careplans/${id}/${plan.DateCreated}`}>
                                            {plan.CarePlanID}
                                        </Link>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="3">No Care Plans available</td>
                            </tr>
                        )}
                    </tbody>
                </Table>
            </div>
        </div>
    );
}

export default CarePlans;
